const config = {
  contactFormName: 'AppOnCloudContact',
  gotConfig: {
    // TODO: remove rejectUnauthorized: false, this is unsecure
    // https: { rejectUnauthorized: false },
  },
  kenticoRoot: process.env.KENTICO_ROOT,
  password: process.env.KENTICO_PASSWORD,
  ttl: 60 * 60 * 1000,
  username: process.env.KENTICO_USERNAME,
};

export default config;
